import { Text, TextProps } from '@mantine/core';

export interface WosIndexAtProps extends TextProps {
  year: number | null;
}

export function WosIndexAt(props: WosIndexAtProps) {
  const { year, ...textProps } = props;

  if (year == null) return null;

  return (
    <Text
      size="sm"
      fw="500"
      c="dimmed"
      {...textProps}
    >
      (Indexat WoS: {year})
    </Text>
  );
}
